import { useNavigate } from "react-router-dom";
import { NEW } from "navigation/Paths";
import { Button, Center } from "@mantine/core";

export const InstrumentPage = () => {
  const navigate = useNavigate();
  return (
    <Center>
      <Button onClick={() => navigate(NEW)}>Start Assessment</Button>
    </Center>
  );
};
